<ng-container *ngIf="icon as ic" [ngSwitch]="ic.type">
  <i *ngSwitchCase="'material-icons'" class="material-icons">{{ ic.name }}</i>
  <i *ngSwitchCase="'bootstrap-icons'" class="bi bi-{{ ic.name }}"></i>
  <i *ngSwitchCase="'font-awesome'" class="fa fa-{{ ic.name }}"></i>
  <span *ngSwitchCase="'mondrian-icons'" class="mdn-Icon-{{ ic.name }} mdn-Icon--{{ ic.size || size }}"
    [attr.aria-label]="ic.name"></span>
</ng-container>